export default __webpack_public_path__ + "static/hero-9344a7487ab189b56b1bd761d77a69d3.svg";